import React, { useState, useEffect } from 'react';

import { Modal, Input } from '@bigcommerce/big-design';

const NewAddressModal = ({ payload, showNewAddressModal, setShowNewAddressModal, address, createLocation, setSubmitted }) => {
  const [label, setLabel] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [company, setCompany] = useState(null);
  const [street1, setStreet1] = useState(null);
  const [street2, setStreet2] = useState(null);
  const [city, setCity] = useState(null);
  const [zip, setZip] = useState(null);
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);

  const addressJson = () => {
    return {
      label: label,
      first_name: firstName,
      last_name: lastName,
      company: company,
      street_1: street1,
      street_2: street2,
      city: city,
      zip: zip,
      country: country,
      state: state
    }
  }

  const create = () => {
    createLocation(payload, addressJson());
    setSubmitted(true);
    setShowNewAddressModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowNewAddressModal(false),
        },
        { text: 'New Address', onClick: () => create() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="New Address"
      isOpen={showNewAddressModal}
      onClose={() => setShowNewAddressModal(false)}
    >
      <Input
        required
        onChange={(e) => setLabel(e.target.value)}
        placeholder="Label"
        label="Label"
        value={label}
        type="text"
      />

      <Input
        onChange={(e) => setFirstName(e.target.value)}
        placeholder="First Name"
        label="First Name"
        value={firstName}
        type="text"
      />

      <Input
        onChange={(e) => setLastName(e.target.value)}
        placeholder="Last Name"
        label="Last Name"
        value={lastName}
        type="text"
      />

      <Input
        onChange={(e) => setCompany(e.target.value)}
        placeholder="Company"
        label="Company"
        value={company}
        type="text"
      />

      <Input
        required
        onChange={(e) => setStreet1(e.target.value)}
        placeholder="Street 1"
        label="Street 1"
        value={street1}
        type="text"
      />

      <Input
        onChange={(e) => setStreet2(e.target.value)}
        placeholder="Street 2"
        label="Street 2"
        value={street2}
        type="text"
      />

      <Input
        required
        onChange={(e) => setCity(e.target.value)}
        placeholder="City"
        label="City"
        value={city}
        type="text"
      />

      <Input
        required
        onChange={(e) => setState(e.target.value)}
        placeholder="State"
        label="State"
        value={state}
        type="text"
      />

      <Input
        required
        onChange={(e) => setCountry(e.target.value)}
        placeholder="Country"
        label="Country"
        value={country}
        type="text"
      />

      <Input
        required
        onChange={(e) => setZip(e.target.value)}
        placeholder="Zip"
        label="Zip"
        value={zip}
        type="text"
      />
    </Modal>
  )
}

export default NewAddressModal;